// TODO: Fix eslint errors.
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */

import latinizeString from 'latinizeString';
import removeSpacesFromText from 'removeSpacesFromText';
import searchParamsStringify from '../../server/utils/searchParamsStringify';

/**
 * Parses elastic search aggregations.
 *
 * @param {object} facets
 *   Elasticsearch aggregations.
 *
 * @returns {{}}
 *   Returns articles facets.
 */
const parseFacets = (facets) => {
  const facetParams = {};
  for (const facetType in facets) {
    if (facets.hasOwnProperty(facetType)) {
      facetParams[facetType] = {};
      if (facets[facetType].buckets !== undefined) {
        facets[facetType].buckets.forEach((item) => {
          if (item.doc_count > 0) {
            facetParams[facetType][item.key] = {
              key: encodeURIComponent(latinizeString(item.key
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .toLowerCase()
                  .replace(/[^a-z0-9]+/g, '-')
                  .replace(/^-+|-+$/g, '')
              )),
              name: item.key,
              checked: false,
            };
          }
        });
      }
    }
  }

  console.log(facetParams);
  return facetParams;
};

/**
 * Builds href for a given facet.
 *
 * @param {string }facetId
 *   Facet id, coming from elastic search.
 * @param {object} searchParams
 *   Search params object.
 * @param {string} pageType
 *   The search page type.
 *
 * @returns {string}
 *   Returns facet's href.
 */
const facetHref = (facetId, searchParams, pageType) => {
  const params = { ...searchParams, ...{ page: null } };
  if (params.hasOwnProperty('facets') && Object.keys(params.facets).length) {
    for (const facetType in params.facets) {
      if (params.facets.hasOwnProperty(facetType)) {
        const facetItems = params.facets[facetType];
        if (facetItems.hasOwnProperty(facetId)) {
          const toCheck = !params.facets[facetType][facetId].checked;
          params.facets[facetType][facetId].checked = toCheck;
          const href = searchParamsStringify(pageType, params);
          params.facets[facetType][facetId].checked = !toCheck;

          return href;
        }
      }
    }
  }
};

const getCurrentCategoryName = (facets) => {
  let currentCategpory = '';
  let categoriesCount = 0;
  for (const facetType in facets) {
    if (facets.hasOwnProperty(facetType)) {
      for (const category in facets[facetType]) {
        if (facets[facetType].hasOwnProperty(category)) {
          const categoryItem = facets[facetType][category];
          if (categoryItem.checked) {
            currentCategpory = categoryItem.name ? categoryItem.name : '';
            categoriesCount++;
          }
        }
      }
    }
  }

  return categoriesCount === 1 ? currentCategpory : '';
};

export { parseFacets, facetHref, getCurrentCategoryName };
